;(function() {
  'use strict';

  /**
   * CSS の非同期読み込み
   */
  var asyncLoadCSS = function () {
    var links = document.querySelectorAll('link.js-async-load-css');
    // NodeList を forEach() する
    Array.prototype.forEach.call(links, function (link) {
      link.rel = 'stylesheet';
    });
  };

  /**
   * DOM content loaded
   */
  $(function() {
    asyncLoadCSS();
  });
}.call(this));
